import React from "react";
import { getGuideSectionVisual as defaultGetVisual, getGuideAccent as defaultGetAccent } from "../../constants/mentalClarityGuideVisuals.js";

const GuidePanel = ({ sectionId, heading, accentIndex = 0, children, getVisual, getAccent }) => {
  const resolveVisual = getVisual || defaultGetVisual;
  const resolveAccent = getAccent || defaultGetAccent;
  const visual = resolveVisual(sectionId);
  const accent = resolveAccent(accentIndex);
  const banner = visual?.banner || "Guide section";

  return (
    <article id={sectionId} className={`guide-panel guide-panel--${accent}`}>
      <div className="guide-panel__banner">{banner}</div>
      <div className="guide-panel__intro">
        {visual?.illustration ? (
          <figure className="guide-panel__figure">
            <img
              src={visual.illustration}
              alt={visual.illustrationAlt || ""}
              className="guide-panel__illus"
              width={280}
              height={182}
              loading="lazy"
              decoding="async"
            />
            <div className="guide-panel__decor" aria-hidden="true" />
          </figure>
        ) : null}
        <h2 className="guide-panel__heading">{heading}</h2>
      </div>
      <div className="guide-panel__body">{children}</div>
    </article>
  );
};

export default GuidePanel;
